import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Home } from '@/components/pages/Home';
import { DatingHistory } from '@/components/pages/DatingHistory';
import { Report } from '@/components/pages/Report';
import { PatientData } from '@/components/pages/PatientData';

const AppRoutes = () => {
  const location = useLocation();
  return (
    <Routes>
      <Route path="/" element={<Home key={location.key} />} />
      <Route path="/historia-cita" element={<DatingHistory />} />
      <Route path="/reporte" element={<Report />} />
      <Route path="/paciente-datos" element={<PatientData />} />
    </Routes>
  );
};

export default AppRoutes;
